import React from 'react';
import PropTypes from 'prop-types';

import Styles from './HelpLinks.styles';

const HelpLinks = ({ children }) => (
  <div className={Styles.default}>{children}</div>
);

HelpLinks.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HelpLinks;
